import PostForm from "../components/Post/PostForm";

const PostFormPage = (): JSX.Element => {
  return <PostForm />;
};

export default PostFormPage;
